/* Model */
class ManagerDashboardModel extends App.Models.BaseModel {
  modelUrl = 'ManagerDashboard';
}

App.Models.ManagerDashboard = ManagerDashboardModel;

/* Collection */
class ManagerDashboardCollection extends App.Collections.BaseCollection {
  url = 'ManagerDashboard';
  model = App.Models.ManagerDashboard;
}

App.Collections.ManagerDashboards = ManagerDashboardCollection;

/* Router */
class ManagerDashboardRouter extends App.Routers.BaseRouter {
  constructor() {
      const entityName = 'ManagerDashboard';
      const model = App.Models.ManagerDashboard;
      const collectionClass = App.Collections.ManagerDashboards;

      super(entityName, model, collectionClass);
  }
}

App.Routers.ManagerDashboard = ManagerDashboardRouter;